import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ResponseEnvelope, makeResponseEnvelope } from "./response-envelope";
import { RestHttp, RestHttpHeaders, RestHttpParams } from "./rest-http.service";

export abstract class ReadableApi<M extends object> {
  abstract modelPath: string;
  protected headers?: RestHttpHeaders;

  constructor(protected rest: RestHttp) {}

  getById(id: number, params?: RestHttpParams): Observable<M> {
    return this.rest
      .get([this.modelPath, id], params, "json", this.headers)
      .pipe(map((res) => this.jsonToModel(this.getModelFromResponse(res))));
  }

  getByFilter(params?: RestHttpParams): Observable<ResponseEnvelope<M>> {
    return this.rest.get(this.modelPath, params, "json", this.headers).pipe(
      map((res: any) => {
        const totalRecords: number =
          res.totalCount != null ? res.totalCount : res.totalRecords;
        return makeResponseEnvelope(
          res.data.map((json) => this.jsonToModel(json)),
          totalRecords
        );
      })
    );
  }

  protected getModelFromResponse(res: any): object {
    const out: object | undefined = this.unwrapSingle(res);
    if (out == null) {
      // TODO: add errors
      throw new Error("not found");
    }
    return out;
  }

  // TODO: get a better function name
  protected unwrapSingle(json: any): M | undefined {
    if (Array.isArray(json.data)) {
      return json.data.length > 0 ? json.data[0] : undefined;
    }
    if (json.data != null && Object.keys(json).length === 1) {
      return json.data;
    }
    return json;
  }

  protected jsonToModel(json: object): M {
    return json as any;
  }
}
